<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="厂商名称">
              <a-input size="small" v-model="queryParam.query_name_like" placeholder="厂商名称"/>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="地址">
              <a-input size="small" v-model="queryParam.query_address_like" placeholder="地址"/>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="电话">
              <a-input size="small" v-model="queryParam.query_phone_like" placeholder="电话"/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :span="6">
              <a-form-item label="邮编">
                <a-input size="small" v-model="queryParam.query_post_like" placeholder="邮编"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden', } || {} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>
    <div class="table-operations">
      <a-button size="small" type="primary" @click="goToAdd">添加</a-button>
      <p></p>
    </div>
    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a-button size="small" @click="goToUpdate(record.id)">修改</a-button>
        <a-divider type="vertical"/>
        <a-button size="small" type="danger" @click="deleteById(record.id)">删除</a-button>
      </span>
    </a-table>
  </div>
</template>
<script>
export default {
  name: "manufacturerIndex",
  mounted() {},
  created() {
    this.queryParamRest();
  },
  data() {
    return {
      productGroup: [],
      httpRoot: "http://localhost",
      productStateList: [],
      brandList: [],
      advanced: false,
      queryParam: {},
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "厂商名称",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "地址",
          dataIndex: "address",
          sorter: true
        },
        {
          title: "电话",
          dataIndex: "phone",
          sorter: true
        },
        {
          title: "邮编",
          dataIndex: "post",
          sorter: true
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/manufacturer/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = {};
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },
    deleteById: function(id) {
      this.$http.get("/api/1.0/manufacturer/delete/" + id).then(res => {
        this.reloadTable();
      });
    },
    goToAdd() {
      this.$router.push({
        path: "/manufacturer/add"
      });
    },
    goToUpdate(id) {
      this.$router.push({
        path: "/manufacturer/update/" + id
      });
    },

    toggleAdvanced() {
      this.advanced = !this.advanced;
    }
  }
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>